import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyB04z2PjUmPv2hLyGn29-woP3weqskTsIQ",
    authDomain: "credible-nation-469520-r6.firebaseapp.com",
    projectId: "credible-nation-469520-r6",
    storageBucket: "credible-nation-469520-r6.firebasestorage.app",
    messagingSenderId: "472518405614",
    appId: "1:472518405614:web:5164c6d54c3a23da81f2ff"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);